module.exports = __webpack_public_path__ + "static/img/fuselage_653K.26b2e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/fuselage_653K.jpg
// module id = k/8k
// module chunks = 0